/* eslint-disable no-console */
import React from 'react';
import {AsyncButton, DatePicker, Select, Checkbox} from '@nike/ruxac';
import {setResetIndicator} from '../Actions/loading';
import {connect} from 'react-redux';
import {loadDataFromAPI} from '../APIs/dataHelper';
//import Location from "./Location";
import {setBeginDateFilter, setEndDateFilter, setFormatVersionFilter, setFullDump} from '../Actions/filters';
import {checkForToken, login} from '../APIs/loginHelper';

export class Filters extends React.Component {

    render() {
        const submitFilters = () => {
            const jwt = checkForToken ();
            if (!jwt || !jwt.accessToken) {
                //redirect to SSO if no jwt present
                console.log("NO JWT");
                alert('Token is expired...redirecting to Okta');
                login ();
            }
            else {
                this.props.loadDataFromAPI(this.props.filters, jwt.accessToken, this.props.userInfo.userName);

            }
        };
        const beginDateTokenized = this.props.filters.beginDate.split('-');
        const endDateTokenized = this.props.filters.endDate.split('-');
        const maxDateTokenized = this.props.filtersData.maxDate.split('-');
        const minDateTokenized = this.props.filtersData.minDate.split('-');
        return (
            <div className={`filter-container-outer`}>
                <div className={'row filter-container-inner'}>
                    <div className={`col-xs-2 margin-right`}>
                        <div className="label">MATERIAL <br/> SUPPLIED MATERIAL<br/> MATERIAL COLOR
                        </div>
                    </div>
                    <div className={`col-xs-2 margin-right `}>
                        <DatePicker
                            className="filter-component"
                            autoOk={true}
                            label="*Begin Date"
                            placeholder="Please select the begin date"
                            minDate={new Date(minDateTokenized[0], minDateTokenized[1] - 1, minDateTokenized[2])}
                            maxDate={new Date(maxDateTokenized[0], maxDateTokenized[1] - 1, maxDateTokenized[2])}
                            value={new Date(beginDateTokenized[0], beginDateTokenized[1] - 1, beginDateTokenized[2])}
                            disabled={this.props.filters.fullDump}
                            onChange={(value) => {
                                const valueString = (new Date(value).getFullYear() + '-' + (new Date(value).getMonth() + 1) + '-' + new Date(value).getDate());
                                this.props.setBeginDateFilter(valueString);
                                const checkEndDate = new Date(endDateTokenized[0], endDateTokenized[1] -1, endDateTokenized[2]);
                                if(value >= checkEndDate)
                                    this.props.setEndDateFilter(valueString);
                            }}
                        />
                    </div>
                    <div className={`col-xs-2 margin-right`}>
                        <DatePicker
                            className="filter-component"
                            autoOk={true}
                            label="*End Date"
                            placeholder="Please select the end date"
                            minDate={new Date(beginDateTokenized[0], beginDateTokenized[1] - 1, beginDateTokenized[2])}
                            maxDate={new Date(new Date(maxDateTokenized[0], maxDateTokenized[1] - 1, maxDateTokenized[2]))}
                            value={new Date(endDateTokenized[0], endDateTokenized[1] -1, endDateTokenized[2])}
                            disabled={this.props.filters.fullDump}
                            onChange={(value) => {
                                const valueString = (new Date(value).getFullYear() + '-' + (new Date(value).getMonth() + 1) + '-' + new Date(value).getDate());//(moment(value).year() + '-' + (moment(value).month() + 1) + '-' + moment(value).date());
                                this.props.setEndDateFilter(valueString);

                            }}
                        />
                    </div>
                    <div className={`col-xs-2`}>
                        <Select
                            label="FORMAT VERSION"
                            className="filter-component"
                            options={[
                                {value : 'V1.0', label : 'V1.0'},
                                {value : 'V1.1', label : 'V1.1'},
                                {value : 'V1.2', label : 'V1.2'}
                            ]}
                            placeholder="V1.0"
                            disabled={this.props.filters.fullDump}
                            allowClear
                            value={this.props.filters.version}
                            onChange={(value) => {
                                this.props.setFormatVersionFilter(value);
                            }}
                        />
                    </div>
                    {(this.props.filters.version === 'V1.1' || this.props.filters.version === 'V1.2'  ) && <div className={`checkbox data-dump`}>
                        <Checkbox
                            label="FULL DATA DUMP"
                            onChange={()=>this.props.setFullDump(this.props.filters.fullDump)}
                            value = {this.props.filters.fullDump}
                        />
                    </div>}
                    <div className={`col-xs-2 submit-btn `}>

                        <AsyncButton
                            onClick={submitFilters}
                        >
                            Submit
                        </AsyncButton>
                    </div>
                </div>
                <div>
                </div>
            </div>



        );
    }
}
const mapStateToProps = (state) => {
    return {
        filters     : state.filters,
        userInfo    : state.userInfo,
        filtersData : state.filtersData
    };
};

const mapDispatchToProps = {
    loadDataFromAPI,
    setResetIndicator,
    setBeginDateFilter,
    setEndDateFilter,
    setFormatVersionFilter,
    setFullDump
};

export default connect(mapStateToProps, mapDispatchToProps)(Filters);



// WEBPACK FOOTER //
// ./src/Components/Filters.js